export default "__VITE_ASSET__XI3FTUd3__"